import genererGuid from '@/services/general/genererGuid';

export default function genererEcheancierManuelContrat(bailleur) {
  return {
    debutPeriode: null,
    finPeriode: null,
    dateEcheance: null,
    devisCommandeId: null,
    key: genererGuid(),
    listeProduits: [],
    modeReglementId: bailleur?.modeReglementId || null,
    commentaire: null,
    aRapprocher: bailleur.surFacture,
    montantFactureTtc: 0,
    montantHt: 0,
    montantPaye: 0,
    montantTtc: 0,
    montantTva: 0,
    pourcentageTva: 0,
    selected: false,
    tiersId: bailleur.tiersId,
    tiers: {
      nomCommercial: bailleur.tiers.nomCommercial,
    },
    listeProduitsLocationEtDivers: [],
    produitAchatId: null,
  };
}
